// src/hooks/results/useResultRowNavigation.js

import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { buildResultPath } from "../../utils/results/resultNavigation";

export function useResultRowNavigation({ variant, context, tab }) {
  const navigate = useNavigate();

  return useCallback(
    (row) => {
      const docid = row?.id;
      if (!docid) return;

      const path = buildResultPath({
        variant,
        docid,
        context,
        tab,
      });

      if (!path) return;

      navigate(path);
    },
    [navigate, variant, context, tab],
  );
}
